export const LANDING = "/";
export const SIGN_UP = "/signup";
export const SIGN_IN = "/signin";
export const HOME = "/home";
export const ABOUT = "/about";
export const ADMIN = "/admin";
export const PROJECT = "/project";
